<template>
  <div class="leftmenu" v-cloak>
    <el-row class="tac">
      <el-col :span="24">
        <el-menu :unique-opened="uniqueOpened" :default-active="activeIndex" :class="activeIndex" :router="true" class="el-menu-vertical-demo" :collapse="$store.getters.isCollapse">
          <el-submenu v-for="(menu,menuIndex) in menuList" :key="menuIndex" :index="(menuIndex).toString()">
            <template slot="title">
              <i class="el-icon" v-if="'/'+menu.subMenuList[0].menuUrl == activeIndexIcon" :class="'icon'+menu.menuId+'-active'"></i>
              <i class="el-icon" v-else :class="'icon'+menu.menuId"></i>
              <span>{{menu.menuName}}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item v-for="(submenu,submeuIndex) in menu.subMenuList" :key="submeuIndex" :class="`${submenu.menuUrl} ${(submenu.menuId=='903'&&roleName!='ADMIN'&&roleName!='FINANCE')||(submenu.menuId=='905'&&roleName!='ADMIN'&&roleName!='FINANCE')?'displayClass':''}`" :index="'/' + submenu.menuUrl">
<!--                <div v-if="submenu.menuId=='903'&&roleName!='ADMIN'&&roleName!='FINANCE'"></div>-->
                <div>{{submenu.menuName}}</div>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import bus from '../../assets/js/bus'
  import http from "../../assets/js/http.js";
  import cookie from '../../assets/js/cookie';
  import utils from '../../assets/js/utils';
  import {mapGetters} from "vuex"

  export default {
    data () {
      return {
        uniqueOpened:true,
        activeClass:"",
        organId:"",
        roleName:""//判断登录的人是什么身份
      }
    },
    mounted(){
      if (localStorage.getItem("roleName")) {
        this.roleName=localStorage.getItem("roleName");
      }
      //console.log(this.roleName)
      this.$nextTick(function(){
        var that = this;
        bus.$on('changeWidth', function(){
          that.changeWidth();
        });

        window.addEventListener('resize', function(){
          setTimeout(function(){
            that.changeWidth();
          },200)
        });
        document.getElementById("logo").addEventListener("mouseenter",function(){
          if(that.$store.getters.isCollapse){
            document.getElementsByClassName("logoImg")[0].style.display = 'none';
            document.getElementsByClassName("logoHoverImgOpen")[0].style.display = 'block';
            document.getElementsByClassName("logoHoverImgClose")[0].style.display = 'none';
          } else {
            document.getElementsByClassName("logoImg")[0].style.display = 'none';
            document.getElementsByClassName("logoHoverImgOpen")[0].style.display = 'none';
            document.getElementsByClassName("logoHoverImgClose")[0].style.display = 'block';
          }
        });
        document.getElementById("logo").addEventListener("mouseleave",function(){
          document.getElementsByClassName("logoImg")[0].style.display = 'block';
          document.getElementsByClassName("logoHoverImgOpen")[0].style.display = 'none';
          document.getElementsByClassName("logoHoverImgClose")[0].style.display = 'none';
        })
      })
    },
    computed:mapGetters({
      menuList:"menuList",
      activeIndex:"activeIndex",
      activeIndexIcon:"activeIndexIcon"
    }),
    created(){

      var that = this;
      this.$nextTick(function () {
        if (localStorage.getItem('menuList')){
          that.$store.commit('getMenuList');
          //this.menuList=JSON.parse(localStorage.getItem('menuList'))
        } else {
          let params={"pageIndex": 1, "pageSize": 0};
          http.menuList(that, params,function (response){
            if (response.data.resultCode=='0'){
              //that.menuList=response.data.result
              localStorage.setItem('menuList',JSON.stringify(response.data.result));
              that.$store.commit('getMenuList');
              //that.menuList = response.data.result;
            }
          })
        }

      })

      // var that = this;
      // if (localStorage.getItem('menuList')){
      //   //this.menuList=JSON.parse(localStorage.getItem('menuList'))
      // } else {
      //   let params={"pageIndex": 1, "pageSize": 0};
      //   http.menuList(that, params,function (response){
      //     if (response.data.resultCode=='0'){
      //       //that.menuList=response.data.result
      //       localStorage.setItem('menuList',JSON.stringify(response.data.result));
      //       //that.$store.state.menuList = response.data.result;
      //     }
      //   })
      // }
      // for(var i=0;i < that.menuList.length; i++){
      //   let operatorType=cookie.getCookie("operatorType")
      //   if (that.menuList[i].menuId == 10 && operatorType == "RESIDENCE") {
      //     that.menuList.splice(i,1);
      //   } else if (that.menuList[i].menuId == 20 && operatorType == "APARTMENT") {
      //     that.menuList.splice(i,1);
      //   }
      //   if(that.menuList[i].menuId == 70 && operatorType=='RESIDENCE'){
      //     that.menuList.splice(i,1);
      //   }
      // }
      // for(var i = 0; i < that.menuList.length; i++){
      //   for(var j = 0; j < that.menuList[i].subMenuList.length; j++){
      //     console.log(("/" + that.menuList[i].subMenuList[j].menuUrl) , that.activeIndex)
      //     if(("/" + that.menuList[i].subMenuList[j].menuUrl) == that.activeIndex){
      //       //console.log(that.menuList[i].menuName,that.menuList[i].subMenuList[j].menuName,'/'+that.menuList[i].subMenuList[j].menuUrl,'/'+that.menuList[i].subMenuList[0].menuUrl)
      //       this.$store.commit('home_Menu',that.menuList[i].menuName);
      //       this.$store.commit('sub_Menu',that.menuList[i].subMenuList[j].menuName);
      //       this.$store.commit('active_Index','/'+that.menuList[i].subMenuList[j].menuUrl);
      //       this.$store.commit('active_IndexIcon','/'+that.menuList[i].subMenuList[0].menuUrl);
      //       // that.$store.state.homeMenu = that.menuList[i].menuName;
      //       // that.$store.state.subMenu = that.menuList[i].subMenuList[j].menuName;
      //       // that.$store.state.activeIndex = '/'+that.menuList[i].subMenuList[j].menuUrl;
      //       // that.$store.state.activeIndexIcon = '/'+that.menuList[i].subMenuList[0].menuUrl;
      //     }
      //   }
      // }
    },
    methods: {
      changeWidth(){
        var that = this;
        that.$store.commit('changeWidth');
        var margin;
        margin = window.innerWidth >= 1280 ? '7.5px 52.5px' : '7.5px 12.5px';
        if(document.getElementsByClassName("logoImg")[0] != undefined){
          document.getElementsByClassName("logoImg")[0].style.margin = margin;
        }
        if(document.getElementsByClassName("logoHoverImgClose")[0] != undefined){
          document.getElementsByClassName("logoHoverImgClose")[0].style.margin = margin;
        }
        if(document.getElementsByClassName("logoHoverImgOpen")[0] != undefined){
          document.getElementsByClassName("logoHoverImgOpen")[0].style.margin = margin;
        }
        if(document.getElementById('container') != undefined && document.getElementById('container') != null) {
          clearTimeout(that.timer);
          if(that.$store.getters.isCollapse){
            that.timer = setTimeout(()=>{
              document.getElementById('container').style.marginLeft = '70px';
            },200)
          } else {
            that.timer = setTimeout(()=>{
                document.getElementById('container').style.marginLeft = '150px';
            },200)
          }
        }
      },
    }
  }
</script>
<style lang="scss" type="text/css">
  @import '../../assets/css/components/_icon.scss';
  $leftBackgroundColor:#162231;
  $iconarrowColor:#fff;
  $iconColor:#fff;
  $noactiveColor:#4d5f77;
  $leftMenuPaddingRight:15px;

  $themeColor:#e96c3f;
  $titleColor:#fff;
  $activeColor:#fff;
  $noactiveColor:#4d5f77;
  $leftMenuWidth:150px;

  .icon10{
    background: url("../../assets/icons/menu-apartment.svg");
  }
  .icon20{
    background: url("../../assets/icons/menu-houses.svg");
  }
  .icon25{
    background: url("../../assets/icons/storeIcon.svg");
  }
  .icon30{
    background: url("../../assets/icons/menu-bill.svg");
  }
  .icon40{
    background: url("../../assets/icons/menu-work-order.svg");
  }
  .icon60{
    background: url("../../assets/icons/menu-wechat.svg");
  }
  .icon61{
    background: url("../../assets/icons/menu-release.svg");
  }
  .icon70{
    background: url("../../assets/icons/menu-finance.svg");
  }
  .icon80{
    background: url("../../assets/icons/menu-account-number.svg");
  }
  .icon90{
    background: url("../../assets/icons/menu-assets.svg");
  }

  .icon10-active{
    background: url("../../assets/icons/menu-apartment-active.svg");
  }
  .icon20-active{
    background: url("../../assets/icons/menu-houses-active.svg");
  }
  .icon25-active{
    background: url("../../assets/icons/storeIcon-s.svg");
  }
  .icon30-active{
    background: url("../../assets/icons/menu-bill-active.svg");
  }
  .icon40-active{
    background: url("../../assets/icons/menu-work-order-active.svg");
  }
  .icon60-active{
    background: url("../../assets/icons/menu-wechat-active.svg");
  }
  .icon61-active{
    background: url("../../assets/icons/menu-release-active.svg");
  }
  .icon70-active{
    background: url("../../assets/icons/menu-finance-active.svg");
  }
  .icon80-active{
    background: url("../../assets/icons/menu-account-number-active.svg");
  }
  .icon90-active{
    background: url("../../assets/icons/menu-assets-active.svg");
  }
  .leftmenu{
    /*打开*/
    .el-menu.el-menu-vertical-demo:not(.el-menu--collapse){
      top: 60px;
      left: 0;
      width: 150px;
      min-width: 150px;
      bottom: 0;
      position: fixed;
      z-index: 99;
      height: auto;
      border-radius: 0;
      background:$leftBackgroundColor;
      .el-submenu{
        .el-submenu__title{
          height: 60px;
          line-height: 60px;
          color:$noactiveColor;
        }
        .el-menu-item-group__title{
          display: none;
        }
        .el-submenu__title:hover{
          background: transparent;
          span{
            color: $activeColor;
          }
        }
        .el-icon{
          color: $iconColor;
          width: 18px;
          height:18px;
          padding-left: 0;
          margin-right: 10px;
        }
        .el-submenu__icon-arrow{
          margin-top: -5px;
        }
        .el-icon-arrow-down:before{
         content: "";
        }
        .el-icon-arrow-down{
          width: 9px;;
          height: 9px;
          background: url("../../assets/icons/menu-arrow-right.svg");
        }
        .el-menu{
          background:$leftBackgroundColor;
          color:$leftBackgroundColor;
        }
        .el-menu-item{
          min-width: 150px;
          height: 40px;
          line-height: 40px;
          color:$noactiveColor;
          div{
            padding-left: 10px;
          }
        }
      }
      .el-submenu.is-active{
        .el-menu-item-group__title{
          display: none;
        }
        span{
          color: $activeColor;
        }
      }
      .el-submenu.is-opened{
        .el-submenu__title{
          color:$activeColor;
          .el-submenu__icon-arrow.el-icon-arrow-down{
            transform: rotateZ(90deg);
          }
        }
        .el-submenu__title:hover{
          background: transparent;
        }
        .el-menu-item-group__title{
          display: none;
        }
        .el-menu-item-group>ul{
          background: $leftBackgroundColor;
          .el-menu-item.is-active{
            background: #0c1a2d;
            color: $activeColor;
          }
        }
        .el-menu-item{
          height: 40px;
          line-height: 40px;
          min-width: 150px;
          div{
            padding-left: 10px;
          }
        }
        .el-menu-item:hover{
          background: transparent;
          color: $activeColor;
        }
      }
    }
    /*关闭*/
    .el-menu.el-menu-vertical-demo.el-menu--collapse{
      top: 60px;
      left: 0;
      width: 70px;
      min-width: 70px;
      bottom: 0;
      position: fixed;
      z-index: 9;
      height: auto;
      border-radius: 0;
      background:$leftBackgroundColor;
      .el-submenu{
        .el-menu{
          width: 120px;
          background:#0c1a2d;
          color:$noactiveColor;
          margin-left: 0;
          border-radius: 0;
          .el-menu-item{
            height: 40px;
            line-height: 40px;
          }
        }
        .el-menu-item-group__title{
          display: none;
        }
        .el-menu-item{
          min-width: 120px;
          color:$noactiveColor;
          padding: 0;
        }
        .el-submenu__title{
          height: 60px;
          line-height: 60px;
          color:$noactiveColor;
        }
        .el-submenu__title:hover{
          background: transparent;
          span{
            color: $activeColor;
          }
         }
        .el-icon{
          color: $iconColor;
          width: 18px;
          height:18px;
          padding-left: 0;
          margin-right: 0px;
        }
      }
      .el-submenu.is-opened{
          background:#0c1a2d;
        .el-menu{
          width: 120px;
          background:#0c1a2d;
          color:$noactiveColor;
          margin-left: 0;
        }
        .el-menu-item{
          min-width: 120px;
          color:$noactiveColor;
          padding: 0;
        }
        .el-menu-item-group__title{
          display: none;
        }
        .el-menu-item.is-active{
          height: 60px;
          line-height: 60px;
          color: $activeColor;
          div{
            padding-right: 20px;
          }
        }
        .el-menu-item.is-active:hover{
          background: #0c1a2d;
          color: $activeColor;
        }
        .el-menu-item{
          height: 40px;
          line-height: 40px;
        }
        .el-menu-item:hover{
          background: #1f2f43;
          color: $activeColor;
        }
      }
      .el-submenu.is-active{
        /*background:#0c1a2d;*/
        .el-menu{
          width: 120px;
          background:#0c1a2d;
          color:$noactiveColor;
          margin-left: 0;
        }
        .el-menu-item{
          min-width: 120px;
          color:$noactiveColor;
          padding: 0;
        }
        .el-menu-item-group__title{
          display: none;
        }
        .el-menu-item.is-active{
          height: 60px;
          line-height: 60px;
          color: $activeColor;
          div{
            padding-right: 20px;
          }
        }
        .el-menu-item.is-active:hover{
          background: #0c1a2d;
          color: $activeColor;
        }
        .el-menu-item{
          height: 40px;
          line-height: 40px;
        }
        .el-menu-item:hover{
          background: #1f2f43;
          color: $activeColor;
        }
      }
    }
  }
  .displayClass{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// leftMenu.vue?e51976b8